import React, { useContext, useState } from "react";
import { mapEdgesToNodes } from "../../lib/helpers";
import { graphql, useStaticQuery } from "gatsby";
import { QuotePanels } from "./quote-panels";
import { Button } from "../button";
import { ArrowLeft } from "../icon/arrow-left";
import { SiteContext } from "../global/site-context";
import { Tweets } from "./snowflake/tweets";
import { SectionHeaders } from "./wrapper";

export const quoteWallQuery = graphql`
  query QuoteWallQuery {
    # confirm this does not bloat page data size
    docs: allSanityQuotable(
      sort: { fields: [orderRank] }
      filter: { _rawExcerpt: { ne: null } }
    ) {
      edges {
        node {
          ...Quotable
        }
      }
    }
    homepage: allSanityQuotable(
      sort: { fields: [orderRank] }
      filter: {
        isPublished: { eq: true }
        _rawExcerpt: { ne: null }
        url: { eq: null }
        categories: {
          elemMatch: { _id: { in: ["429d6b97-3b6d-4f55-9eb8-13589d5ea01a"] } }
        }
        headline: { eq: null }
        companies: {
          elemMatch: { mainImage: { asset: { _id: { ne: null } } } }
        }
      }
      limit: 8
    ) {
      edges {
        node {
          ...Quotable
        }
      }
    }
  }
`;

export const QuoteWall = ({ section }) => {
  const site = useContext(SiteContext);
  const results = useStaticQuery(quoteWallQuery) || {};
  const isHomepage = section?.category === "homepage";
  const allQuotes = mapEdgesToNodes(isHomepage ? results.homepage : results.docs);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");

  const categories = !isHomepage
    ? [...new Map(
      allQuotes.flatMap((q) => q.categories || []).map((c) => [c._id, c])
    ).values()].sort((a, b) => a.title.localeCompare(b.title))
    : [];

  const companies = !isHomepage
    ? [...new Map(
      allQuotes.flatMap((q) => q.companies || []).map((c) => [c._id, c])
    ).values()].sort((a, b) => a.title.localeCompare(b.title))
    : [];

  const quotes = allQuotes.filter((q) => {
    if (selectedCategory) return q.categories?.some((c) => c._id === selectedCategory);
    if (selectedCompany) return q.companies?.some((c) => c._id === selectedCompany);
    return true;
  });

  const selectClass =
    "border border-dark-20 rounded-lg px-3 py-2 text-sm bg-transparent cursor-pointer focus:outline-none focus:ring-2 focus:ring-link";

  return (
    <>
      {!isHomepage && (categories.length > 0 || companies.length > 0) && (
        <div className="flex flex-wrap gap-3 mb-8">
          {categories.length > 0 && (
            <select
              className={selectClass}
              value={selectedCategory}
              onChange={(e) => { setSelectedCategory(e.target.value); setSelectedCompany(""); }}
            >
              <option value="">All Categories</option>
              {categories.map((c) => (
                <option key={c._id} value={c._id}>{c.title}</option>
              ))}
            </select>
          )}
          {companies.length > 0 && (
            <select
              className={selectClass}
              value={selectedCompany}
              onChange={(e) => { setSelectedCompany(e.target.value); setSelectedCategory(""); }}
            >
              <option value="">All Companies</option>
              {companies.map((c) => (
                <option key={c._id} value={c._id}>{c.title}</option>
              ))}
            </select>
          )}
          {(selectedCategory || selectedCompany) && (
            <button
              className="text-sm text-secondary hover:text-primary underline"
              onClick={() => { setSelectedCategory(""); setSelectedCompany(""); }}
            >
              Clear
            </button>
          )}
        </div>
      )}
      <QuotePanels quotes={quotes} showCardLogo={true} />
      <div className="flex justify-center mt-12">
        <Button
          text="See our customer stories"
          bgColor="bg-light-10"
          icon={<ArrowLeft rotate={180} />}
          iconRight={true}
          isSmall={true}
          href="/customers/"
        />
      </div>
      {site.isHomepage && (
        <div className="pt-16 md:pt-24">
          <SectionHeaders
            {...{
              ...section,
              header: "We appreciate you all, too.",
              _rawSummary: [],
            }}
          />
          <Tweets />
        </div>
      )}
    </>
  );
};
